function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDuplicate(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 17.5,
    height: 17.5,
    viewBox: "0 0 17.5 17.5",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    "data-name": "copy (3)",
    transform: "translate(-1.25 -1.25)"
  }, /*#__PURE__*/React.createElement("rect", {
    "data-name": "Rectangle 9159",
    width: 10.4,
    height: 10.4,
    rx: 2,
    transform: "translate(7.6 7.6)",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 46874",
    d: "M4.4 12.4h-.8A1.6 1.6 0 0 1 2 10.8V3.6A1.6 1.6 0 0 1 3.6 2h7.2a1.6 1.6 0 0 1 1.6 1.6v.8",
    style: {
      fill: "none",
      stroke: "#6c7c8c",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "1.5px"
    }
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDuplicate);
export default __webpack_public_path__ + "static/media/duplicate.83f09148b6737d5c83b083b93777b478.svg";
export { ForwardRef as ReactComponent };